module.exports = __webpack_public_path__ + "img/pos_khuyen_mai.f1ed171b.png";